import { render } from "./ConfirmsPassword.vue?vue&type=template&id=b8603d68"
import script from "./ConfirmsPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmsPassword.vue?vue&type=script&lang=js"

import exportComponent from "/home/dschranka/actions-runner/_work/DSchranka/DSchranka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__